import React from 'react';

import './Target.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {useActions} from "../../../hooks/useActions";


function TargetPlayUnit({tableKey, table, side, addClass}) {

    const {phase, playedCard, playerTable} = useTypedSelector(state => state.game);
    const {playCard, setPlayedCard, setPhase, setPlayerTable} = useActions();

    let targetClasses = 'tableTarget';
    let showPlayUnitTarget = false;

    if (phase === 'select_unit_target' && playedCard.target === null && table[tableKey] === 0 && side === 'player') {
        targetClasses += ' tableTargetActive  buc_cell_' + tableKey;
        showPlayUnitTarget = true;
    }

    const setTargetAndPlayUnit = function () {

        playedCard.target = {key: 'table_key', value: tableKey, side: side};
        playCard(playedCard);

        setPlayedCard({card: null, handKey: null, target: null});
        setPhase('play_unit');

        playerTable[tableKey] = {
            card: playedCard.card,
            sleep: false
        }

        setPlayerTable(playerTable);
    }

    return (
        <div className={targetClasses + addClass} onClick={(e) => {
            e.stopPropagation();
            if (showPlayUnitTarget) {
                setTargetAndPlayUnit();
            }
        }}></div>
    );
}

export default TargetPlayUnit;
